<template>
	<div class="sme-listings">
        <div class="py-3">
            <h3>Purchase History</h3>
        </div>
        <div class="my-3">
            <b-col cols="12">
                <b-row class="d-flex align-items-center justify-content-md-between">
                    <b-col cols="12" md="12" class="d-md-flex">
                        <base-input
                            label="Search"
                            v-model="filters.company_name"
                            v-on:input="debouncedHandler"
                            prepend-icon="fas fa-search"
                            placeholder="Search Company"
                        >
                        </base-input>
                        <base-input label="Filter by Request Status" class="mx-4">
                            <el-select
                                v-model="filters.request_status"
                                placeholder="Select Status"
                                @change="filter()"
                                >
                                <el-option value="">
                                    All
                                </el-option>
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </base-input>
                        <base-input label="Filter by Date" class="mx-4">
                            <el-select
                                v-model="filters.date_type"
                                placeholder="Select Date Type"
                                @change="changeDateType"
                                >
                                <el-option value="">
                                    All
                                </el-option>
                                <el-option
                                    v-for="item in dateTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </base-input>
                        <base-input label="Pick Date" class="mx-4" v-if="filters.date_type">
                            <el-date-picker
                                v-model="filters.dates"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                class="sme-field"
                                @change="filterDate"
                                >
                            </el-date-picker>
                        </base-input>
                    </b-col>
                </b-row>
            </b-col>
            <TablePurchaseHistory ref="tablePurchaseHistory" />
        </div>
	</div>
</template>
<script>
import { Select, Option, DatePicker } from 'element-ui'
import TablePurchaseHistory from '@/views/CreditReports/SMEReports/PurchaseHistory/PurchaseHistoryTable.vue'
import {
    debounce,
    helperFunctionMixin
} from '@/assets/js/httpImports.js'

export default {
    mixins: [helperFunctionMixin],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        TablePurchaseHistory
    },
    data() {
        return {
            debouncedHandler: '',
            filters: {
                company_name: null,
                request_status: null,
                request_date: null,
                response_date: null,
                dates: null,
                date_type: null,
                date_start: null,
                date_end: null,
            },
            statusList: [
                {
                    label: 'Completed',
                    value: 'Completed',
                },
                {
                    label: 'Not Completed',
                    value: 'Not Completed',
                },
                {
                    label: 'Pending Payment',
                    value: 'Pending_payment',
                },
            ],
            dateTypes: [
                {
                    label: 'Request Datetime',
                    value: 'credit_report_request_datetime',
                },
                {
                    label: 'Response Datetime',
                    value: 'credit_report_response_datetime',
                },
            ]
        }
    },
    mounted(){
        this.debouncedHandler = debounce(() => {
            this.filter();
        }, 500);
    },
    methods: {
        async filter() {
            await this.$refs.tablePurchaseHistory.getCreditReportsList(this.filters)
        },
        refreshList() {
            this.$refs.tablePurchaseHistory.getCreditReportsList()
        },
        changeDateType() {
            if(!this.filters.date_type) {
                this.filters.dates = null
                this.filters.date_start = null
                this.filters.date_end = null
                this.filter()
            }
        },
        filterDate() {
            if(this.filters.dates) {
                this.filters.date_start = this.formatDate(this.filters.dates[0], 'Y-m-d')
                this.filters.date_end = this.formatDate(this.filters.dates[1], 'Y-m-d')
            } else {
                this.filters.date_start = null
                this.filters.date_end = null
            }
            this.filter()
        }
    }
}
</script>